import React, { useContext, useEffect, useState } from "react"
import MFeedMasonry from "../blocks/m_feed_masonry"
import DfbSpinner from "../ui-kit/dfb_spinner"

import useRemoteHomepageFeedHandler from "../../hooks/useRemoteHomepageFeedHandler"

const MNestedHomepageFeedRemote = ({ data }) => {
  const { uid, headline, subheadline } = data

  data.items_per_page = data.items_per_page || 12

  const { collectionForPage, hasNextPage, totalCount, handleNextPage } =
    useRemoteHomepageFeedHandler(data)

  useEffect(() => {
    if (
      collectionForPage &&
      collectionForPage.length &&
      window.upgradeAllBehaviours
    ) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  useEffect(() => {
    if (collectionForPage && collectionForPage.length > 0) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  if (!collectionForPage || collectionForPage.length === 0) {
    return (
      <section className="m-Error">
        <div className="m-Error-wrapper">
          <div className="m-Error-container">
            <div className="m-Error-content">
              <DfbSpinner type="continuous" autoLoop={true} />
              <br />
              <br />
              <br />
              <p className="m-Error-text">Daten werden geladen …</p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  const feed_type = "m-feed-masonry"

  switch (feed_type) {
    case "m-feed-masonry": {
      return (
        <MFeedMasonry
          key={uid}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          handleNextPage={handleNextPage}
          data={data}
        />
      )
    }
    default: {
      return (
        <div>
          MNestedHomepageFeedRemote with layout "{feed_type}" not implemented.
        </div>
      )
    }
  }
}

export default MNestedHomepageFeedRemote
